import { GenericJSObject } from 'types/Core';

export const fetchBodyFormatter = (json: GenericJSObject): string =>
  `request=${encodeURIComponent(
    JSON.stringify({
      request: json,
    }),
  )}`;
